import { useState } from "preact/compat"
import { useAsyncEffect } from "@/utils"
import { getOauthUrl } from "@/api/integration"
import { CenterColumnContainer } from "@/components/LoginScreen.tsx"
import { LoadingSpinner } from "@/app/loading"
import { OAuthRedirectModal } from "./oauth-redirect-modal"

type OAuthProvider = "gmail" | "microsoft" | "sageintacct" | "xero" | "quickbooks" | "googledrive"

interface OAuthConnectPageProps {
  provider: OAuthProvider
  displayName: string
  returnPath?: string
}

export function OAuthConnectPage({ provider, displayName, returnPath }: OAuthConnectPageProps) {
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  // Default to current path so it works for both /setup/connect/* and /settings/connect/*
  const effectiveReturnPath = returnPath ?? window.location.pathname

  useAsyncEffect(async () => {
    const res = await getOauthUrl(provider, effectiveReturnPath)
    if (!res.ok) {
      console.error(res.error)
      setError(`Failed to get ${displayName} authorization URL. Please try again.`)
      return
    }
    setRedirectUrl(res.value.data)
  }, [])

  if (error) {
    return (
      <CenterColumnContainer>
        <div class="text-center py-8">
          <p class="text-red-600">{error}</p>
        </div>
      </CenterColumnContainer>
    )
  }

  if (!redirectUrl) {
    return (
      <CenterColumnContainer>
        <div class="flex justify-center py-8">
          <LoadingSpinner />
        </div>
      </CenterColumnContainer>
    )
  }

  return <OAuthRedirectModal name={displayName} redirectUrl={redirectUrl} />
}
